import BlankCoupon from '@components/blank/BlankCoupon';
import Column from '@components/Column';
import InfinityScrollTrigger from '@components/InfinityScrollTrigger';
import PullToRefresh from '@components/PullToRefresh';
import styled from '@emotion/styled';

import useMyCoupons from './hooks/useMyCoupons';
import CouponFilter from '../../components/CouponFilter';
import CouponItem from '../../components/CouponItem';
import CouponItemSkeletons from '../../components/CouponItemSkeletons';

function MyCouponFragment() {
    const {
        coupons, fetchNextPage, isEmpty, isFetching, refetch,
    } = useMyCoupons();
    return (
        <PullToRefresh onRefresh={refetch}>
            <Column fullWidth>
                <CouponFilter tab='MY'/>
                <Container fullWidth as='section' align='center' spacing={4}>
                    {coupons?.map((coupon, i) => (
                        <CouponItem coupon={coupon}
                            key={coupon.couponId} />
                    ))}
                    {(isEmpty && !isFetching) && (<BlankCoupon/>)}
                    <InfinityScrollTrigger trigger={fetchNextPage} />
                    {isFetching && (<CouponItemSkeletons count={coupons?.length ? 1 : 5}/>)}
                </Container>
            </Column>
        </PullToRefresh>
    );
}

const Container = styled(Column)`
    padding: 0 var(--spacing-4);  
`;

export default MyCouponFragment;
